/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useRef } from 'react';
import { Field, FieldProps } from 'formik';
import { FormTextField } from 'components/TextField';

import { moneyMask } from 'utils/masks';
import useFieldCustomization from 'hooks/useFieldCustomization';
import withOptional from './withOptional';

const IntendedPurchaseAmountField: React.FC = () => {
  const intendedPurchaseAmountRef = useRef<HTMLDivElement | null>(null);
  const { isRequired, isVisible } = useFieldCustomization();

  if (!isVisible('intendedPurchaseAmount')) {
    return null;
  }

  return (
    <React.Fragment>
      <Field name="intendedPurchaseAmount">
        {(fieldProps: FieldProps) => (
          <FormTextField
            id="creditAppIntendedPurchaseAmount"
            inputRef={intendedPurchaseAmountRef}
            fieldProps={fieldProps}
            required={isRequired('intendedPurchaseAmount')}
            label={withOptional(
              'Intended Purchase Amount',
              isRequired('intendedPurchaseAmount'),
            )}
            mask={moneyMask}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
            }}
          />
        )}
      </Field>
    </React.Fragment>
  );
};

export default IntendedPurchaseAmountField;
